"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.string = exports.iots = exports.record = exports.option = exports.nonEmptyArray = exports.monoid = exports.either = exports.array = exports.map = exports.pipe = void 0;
const tslib_1 = require("tslib");
var function_1 = require("fp-ts/function");
Object.defineProperty(exports, "pipe", { enumerable: true, get: function () { return function_1.pipe; } });
var fp_ts_1 = require("fp-ts");
Object.defineProperty(exports, "map", { enumerable: true, get: function () { return fp_ts_1.map; } });
Object.defineProperty(exports, "array", { enumerable: true, get: function () { return fp_ts_1.array; } });
Object.defineProperty(exports, "either", { enumerable: true, get: function () { return fp_ts_1.either; } });
Object.defineProperty(exports, "monoid", { enumerable: true, get: function () { return fp_ts_1.monoid; } });
Object.defineProperty(exports, "nonEmptyArray", { enumerable: true, get: function () { return fp_ts_1.nonEmptyArray; } });
Object.defineProperty(exports, "option", { enumerable: true, get: function () { return fp_ts_1.option; } });
exports.record = tslib_1.__importStar(require("./record"));
exports.iots = tslib_1.__importStar(require("./iots"));
exports.string = tslib_1.__importStar(require("./string"));
//# sourceMappingURL=index.js.map